import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const UploadFilesAsync = lazyWithRetry(() => import('./upload-files'))
